module.exports = __webpack_public_path__ + "static/media/Buisness-Technology.8e0e010a.jpg";